<template>
  <div>
    <Header />

    <div class="index-banner">
      <swiper :options="swiperOption2" @change="handleClickSlide">
        <!-- <swiper-slide class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
          <a :href="item.url" target="_blank" v-if="item.url">
            <img :src="item.imgUrl" alt="" class="cover" />
          </a>
          <img :src="item.imgUrl" alt="" class="cover" v-else />
        </swiper-slide>-->
        <swiper-slide class="swiper-slide">
          <div class="page">
            <h3 :class="{ bounceInDown:slider_index==0 }">湘潭市政府采购合同融资信息服务平台</h3>
            <p class="slogan" :class="{ fadeInUp:slider_index==0 }">
              以政府采购合同为基础，为中小微企业提供合适的银行合同融资信用<br/>
              贷款产品，解决企业“融资难、融资贵”问题，盘活企业资金，降低融资成本。
            </p>
            <div class="pro-box clearfix">
              <div class="pro-pre" v-for="(item,index) in proList" :key="index">
                <div class="pro-img">
                  <i :class="`icon_${index+1}`"></i>
                </div>
                <p class="pro-topic">{{ item.title }}</p>
              </div>
            </div>
          </div>
          <img src="../assets/img/index/bg.png" alt="" class="cover" />
        </swiper-slide>
        <swiper-slide class="swiper-slide">
          <div class="page">
            <img src="../assets/img/index/title.png" alt="" :class="{ bounceInDown:slider_index==1 }" />
            <div class="small-title">
              <p>在线申请&nbsp;&nbsp;实时审批</p>
              <hr class="content-line">
            </div>
            <p class="slogan slogan2" :class="{ fadeInUp:slider_index==1 }">
              用政府采购合同融资&nbsp;&nbsp;&nbsp;&nbsp;解中小企业融资难题
            </p>
          </div>
          <img src="../assets/img/index/bg.png" alt="" class="cover" />
        </swiper-slide>

        <!--分页-->
        <!--<div class="swiper-pagination swp2" slot="pagination"></div>-->
        <!--滚动条-->
        <div class="swiper-scrollbar" slot="scrollbar"></div>
      </swiper>

      <div class="scrollDownBtn">
        <i></i>
        <img src="../assets/img/arr.png"/>
      </div>


      <div class="home-kind">
        <ul>
<!--          <li v-for="(item,index) in kindList" :key="index" :class="{active: hoverIndex == index}"-->
<!--              @mouseover="hoverIndex = index"-->
<!--              @mouseout="hoverIndex = 0">-->
<!--            <div class="icon">-->
<!--              <i :class="`icon_${index+1}`"></i>-->
<!--            </div>-->
<!--            <h3>{{ item.title }}<span></span></h3>-->
<!--            <span class="number">{{item.endVal}}</span>-->
<!--&lt;!&ndash;            <countTo :startVal='item.startVal' :endVal='item.endVal' :duration='3000' class="number"></countTo>&ndash;&gt;-->
<!--            <p>{{ item.info }}</p>-->
<!--          </li>-->
          <li :class="{active: hoverIndex == 0}" @mouseover="hoverIndex = 0" @mouseout="hoverIndex = 0">
            <div class="icon">
              <i class="icon_1"></i>
            </div>
            <h3>金融产品<span></span></h3>
<!--            <span class="number">{{this.productionCount}}</span>-->
            <countTo :startVal='0' :endVal='this.productionCount' :duration='3000' class="number"></countTo>
            <p>种</p>
          </li>

          <li :class="{active: hoverIndex == 1}" @mouseover="hoverIndex = 1" @mouseout="hoverIndex = 0">
            <div class="icon">
              <i class="icon_2"></i>
            </div>
            <h3>金融机构<span></span></h3>
<!--            <span class="number">{{loanCount}}</span>-->
            <countTo :startVal='0' :endVal='this.loanCount' :duration='3000' class="number"></countTo>
            <p>家</p>
          </li>

          <li :class="{active: hoverIndex == 2}" @mouseover="hoverIndex = 2" @mouseout="hoverIndex = 0">
            <div class="icon">
              <i class="icon_3"></i>
            </div>
            <h3>企业数量<span></span></h3>
<!--            <span class="number">{{this.enterpriseCount}}</span>-->
            <countTo :startVal='0' :endVal='this.enterpriseCount' :duration='3000' class="number"></countTo>
            <p>个</p>
          </li>

          <li :class="{active: hoverIndex == 3}" @mouseover="hoverIndex = 3" @mouseout="hoverIndex = 0">
            <div class="icon">
              <i class="icon_4"></i>
            </div>
            <h3>融资笔数<span></span></h3>
<!--            <span class="number">{{this.orderCount}}</span>-->
            <countTo :startVal='0' :endVal='this.orderCount' :duration='3000' class="number"></countTo>
            <p>笔</p>
          </li>

          <li :class="{active: hoverIndex == 4}" @mouseover="hoverIndex = 4" @mouseout="hoverIndex = 0">
            <div class="icon">
              <i class="icon_5"></i>
            </div>
            <h3>融资发放金额<span></span></h3>
<!--            <span class="number">{{this.orderMoney}}</span>-->
            <countTo :startVal='0' :endVal='this.orderMoney' :duration='3000' class="number" decimals="4"></countTo>
            <p>万元</p>



          </li>
        </ul>
      </div>
    </div>


    <!--产品介绍-->
    <div class="main-cont bg-primary">
      <div class="wrap">
        <div class="main-title">
          <h1>产品介绍</h1>
        </div>
        <div class="product-box clearfix">
          <div class="product-pre">
            <div class="product-item">
              <!--<router-link to="/" target="_blank">-->
                <div class="product-img">
                  <img src="../assets/img/index/pic_01.png" alt="" />
                </div>
                <p class="product-topic">产品丰富</p>
                <div class="product-info">
                  <p>产品多样，自主选择</p>
                </div>
              <!--</router-link>-->
            </div>
          </div>
          <div class="product-pre">
            <div class="product-item">
              <!--<router-link to="/" target="_blank">-->
              <div class="product-img">
                <img src="../assets/img/index/pic_02.png" alt="" />
              </div>
              <p class="product-topic">一键申贷</p>
              <div class="product-info">
                <p>在线申请，流程简化</p>
              </div>
              <!--</router-link>-->
            </div>
          </div>
          <div class="product-pre">
            <div class="product-item">
              <!--<router-link to="/" target="_blank">-->
              <div class="product-img">
                <img src="../assets/img/index/pic_03.png" alt="" />
              </div>
              <p class="product-topic">审批高效</p>
              <div class="product-info">
                <p>在线审批，实时反馈</p>
              </div>
              <!--</router-link>-->
            </div>
          </div>
          <div class="product-pre">
            <div class="product-item">
              <!--<router-link to="/" target="_blank">-->
              <div class="product-img">
                <img src="../assets/img/index/pic_04.png" alt="" />
              </div>
              <p class="product-topic">额度预知</p>
              <div class="product-info">
                <p>贷款额度，在线查询</p>
              </div>
              <!--</router-link>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--融资流程-->
    <div class="main-cont">
      <div class="wrap">
        <div class="main-title">
          <h1>融资流程</h1>
        </div>
        <div class="process-box clearfix">
          <div class="process-pre">
            <span class="step">1</span>
            <div class="process-item">
              <div class="process-img">
                <i class="icon-1"></i>
                <!--<img src="../assets/img/product-1.png" alt="" />-->
              </div>
            </div>
            <p class="process-topic">选择产品</p>
          </div>
          <div class="process-pre">
            <span class="step">2</span>
            <div class="process-item">
              <div class="process-img">
                <i class="icon-2"></i>
              </div>
            </div>
            <p class="process-topic">提交申请</p>
          </div>
          <div class="process-pre">
            <span class="step">3</span>
            <div class="process-item">
              <div class="process-img">
                <i class="icon-3"></i>
              </div>
            </div>
            <p class="process-topic">银行审批</p>
          </div>
          <div class="process-pre">
            <span class="step">4</span>
            <div class="process-item">
              <div class="process-img">
                <i class="icon-4"></i>
              </div>
            </div>
            <p class="process-topic">开立专户</p>
          </div>
          <div class="process-pre">
            <span class="step">5</span>
            <div class="process-item">
              <div class="process-img">
                <i class="icon-5"></i>
              </div>
            </div>
            <p class="process-topic">合同签订</p>
          </div>
          <div class="process-pre">
            <span class="step">6</span>
            <div class="process-item">
              <div class="process-img">
                <i class="icon-6"></i>
              </div>
            </div>
            <p class="process-topic">贷款发放</p>
          </div>
        </div>
      </div>
    </div>

    <!--金融机构-->
    <div class="main-banner plugin-box">
      <div class="main-title">
        <h1>金融机构</h1>
      </div>

      <div class="tool-intro">
        <el-carousel :interval="4000" type="card" :autoplay="false" indicator-position="none">
          <el-carousel-item v-for="(item,index) in bankList" :key="index">
            <div class="list-item">
              <div class="bank-logo">
<!--                <img src="../assets/img/index/bank_logo.png" alt="" />-->
                <img :src="item.logo" alt="" />
              </div>
              <h3 class="bank-medium">产品数：<span>{{item.productionCount}}</span></h3>
              <div class="bank-name"><div>{{item.name}}</div></div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Header from "../components/Header";
import Footer from "../components/Footer";
import countTo from 'vue-count-to';

export default {
  name: "Home",
  components: {
    Header,
    Footer,
    swiper,
    swiperSlide,
    countTo
  },
  data() {
    let self = this;
    return {
      //banner列表
      slider_index: 0,
      bannerList: [],
      //银行产品数量
      bankList: [],
      //企业数量
      enterpriseCount:112,
      //金融产品
      productionCount:1,
      //金融机构
      loanCount:1,
      //融资笔数
      orderCount:32,
      //融资发放金额
      orderMoney:28643423,
      formData: {
          pageNo: 1,
          pageSize: 10,
          projectStatus: "0",
          isRelease: "0"
      },
      datas: [],
      totalItems: 0,
      swiperOption2: {
        direction : 'vertical',
        //循环
        // loop: true,
        //自动播放
        autoplay: {
          delay: 3000
          // stopOnLastSlide: false,
          // disableOnInteraction: false
        },
        // slidesPerView: 3,
        // spaceBetween: 15,
        //滑动速度
        speed: 1000,
        pagination: {
          el: ".swiper-pagination.swp2",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next.swp2",
          prevEl: ".swiper-button-prev.swp2"
        },
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true
        },
        // mousewheel: true, // 鼠标滚轮
        mousewheel: {
          releaseOnEdges: true,// 释放鼠标滚轮事件
        },
        //抵抗率 0时完全无法拖离
        resistanceRatio : 0,
        on: {
          slideChangeTransitionEnd: function(){
            self.slider_index = this.activeIndex;
            // console.log('123', this.activeIndex,self.slider_index)
          },
        }
      },
      // 模拟数据
      proList:[
        {
          title: '授信额度高'
        },
        {
          title: '融资期限长'
        },
        {
          title: '担保方式活'
        },
        {
          title: '贷款利率低'
        }
      ],
      hoverIndex:0,
      kindList:[
        {
          title: '金融产品',
          startVal: 0,
          endVal: this.productionCount,
          info: '种'
        },
        {
          title: '金融机构',
          startVal: 0,
          endVal: this.loanCount,
          info: '家'
        },
        {
          title: '企业数量',
          startVal: 0,
          endVal: this.enterpriseCount,
          info: '个'
        },
        {
          title: '融资笔数',
          startVal: 0,
          endVal: this.orderCount,
          info: '笔'
        },
        {
          title: '融资发放金额',
          startVal: 0,
          endVal: this.orderMoney,
          info: '万元'
        }
      ],
    };
  },
  mounted() {
    this.count();
    this.getBanks();
    this.getProjectList();
  },
  methods: {
    count() {
      let _this = this;
      comFn.ajax({
        // self: layer,
        url: "/loanweb/count",
        data: {},
        success: function (res) {
          _this.orderMoney = (res.orderMoney + _this.orderMoney)/10000;
          _this.orderCount = res.orderCount + _this.orderCount;
          // _this.enterpriseCount = res.enterpriseCount + _this.enterpriseCount;
          _this.loanCount = res.loanCount + _this.loanCount;
          _this.productionCount = res.productionCount + _this.productionCount;

        },
        error: function (res) {
          // layer.close(load);
        }
      });
    },
    getBanks(){
      let _this = this;
      comFn.ajax({
        // self: layer,
        url: "/loanweb/getBankProductions",
        data: {},
        success: function (res) {
          _this.bankList = res;

        },
        error: function (res) {
          // layer.close(load);
        }
      });
    },
    // 滑动点击
    handleClickSlide(index){
      // this.slider_index = index;
      console.log('Click slide!', index);

    },
    // 预留 跳转页
    goLogin() {
      window.open(jumpUrls+"/");
    },
    getProjectList() {
      let _this = this;
      comFn.ajax({
        self: _this,
        url: "/project/page",
        data: _this.formData,
        error(err) {
        },
        success(res) {
          if (res) {
            _this.datas = res.result || [];
            _this.totalItems = res.totalItems || 0;
          }
        },
        complete(msg) {
          // loading.close();
        }
    });
    }
  }
};
</script>

<style lang="scss" scoped>
  .index-banner {
    /*分页*/
    .swiper-pagination {
      .swiper-pagination-bullet {
        outline: none;
        opacity: 0.18;
        margin-right: 6px;
      }
      .swiper-pagination-bullet-active {
        width: 30px;
        height: 8px;
        border-radius: 8px;
        opacity: 0.8;
        background-color: #f75711;
      }
    }
    /*箭头*/
    .swiper-button-prev,
    .swiper-button-next {
      outline: none;
      width: 40px;
      height: 40px;
      background: url("../assets/img/purchase-change-icon.png") no-repeat center;
    }
    .swiper-button-next {
      transform: rotate(180deg);
    }
    /*滚动条*/
    .swiper-container-vertical > .swiper-scrollbar {
      right: 5%;
      top: 18%;
      height: 50%;
      background: rgba(255, 255, 255, 0.1);
    }
    .swiper-scrollbar-drag {
      background: rgba(255, 255, 255, 0.5);
    }
  }

  .tool-intro {
    .el-carousel__item {
      .el-carousel__mask {
        display: none;
      }
    }
    .el-carousel__arrow {
      top: 40%;
      width: 50px;
      height: 50px;
      background: url("../assets/img/index/arrow_l.png") no-repeat center;
      background-size: 100%;
      i {
        display: none;
      }
    }
    .el-carousel__arrow--right {
      background: url("../assets/img/index/arrow_r.png") no-repeat center;
      background-size: 100%;
    }
  }
</style>
<style lang="scss" scoped>
  .index-banner {
    position: relative;
    width: 100%;
    /*height: 100vh;*/
    background: #fff;
    text-align: center;

    .swiper-container {
      height: 740px;
    }
    .swiper-slide,
    a {
      position: relative;
      width: 100%;
      /*height: calc(100vh);*/
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;

      .cover {
        /*object-fit: cover;*/
        object-fit: none;
        object-position:bottom;
        /*vertical-align: top;*/
        /*height: calc(100vh);*/
        height: 100%;
      }

      .page {
        position: absolute;
        top: 20%;
        width: 100%;
        color: #fff;
        text-align: center;
        /*height: 100px;*/
        /*overflow: hidden;*/
        h3 {
          font-size: 38px;
          font-weight: 500;
          letter-spacing:4px;
        }
        .slogan {
          font-size: 20px;
          font-weight: 300;
          line-height: 34px;
          padding: 30px 0;
          letter-spacing:3px
        }

        .pro-box {
          max-width: 800px;
          margin: auto;
          .pro-pre {
            width: 25%;
            float: left;
            .pro-img {
              /*width: 50%;*/
              max-width: 120px;
              margin: 0 auto;
              i {
                display: inline-block;
                width: 100px;
                height: 100px;
                background-position: center;
                background-repeat: no-repeat;
                background-size: 100%;
              }
              .icon_1 {
                background-image: url("../assets/img/index/i_01.png");
              }
              .icon_2 {
                background-image: url("../assets/img/index/i_02.png");
              }
              .icon_3 {
                background-image: url("../assets/img/index/i_03.png");
              }
              .icon_4 {
                background-image: url("../assets/img/index/i_04.png");
              }
            }
            .pro-topic {
              font-size: 16px;
              /*font-weight: 400;*/
              color: #fff;
            }

            &:hover {
              transition: all 2.5s;
              .pro-img {
                i {
                  animation: zoomIn 0.3s linear;
                }
                .icon_1 {
                  background-image: url("../assets/img/index/i_hover_01.png");
                }
                .icon_2 {
                  background-image: url("../assets/img/index/i_hover_02.png");
                }
                .icon_3 {
                  background-image: url("../assets/img/index/i_hover_03.png");
                }
                .icon_4 {
                  background-image: url("../assets/img/index/i_hover_04.png");
                }
              }
              .pro-topic {
                text-shadow: 0px 3px 9px rgba(54, 204, 250, 0.69);
              }
            }
          }
        }

        img {
          width: 40%;
          min-width: 340px
        }
        .small-title {
          margin-top: 30px;
          p {
            font-size: 18px;
            letter-spacing:2px
          }
          .content-line {
            width: 60px;
            height: 2px;
            background: rgba(255, 255, 255, .6);
            margin: 10px auto 40px;
          }
        }
        .slogan2 {
          font-size: 26px;
          text-shadow: 0px 3px 9px rgba(98, 107, 201, 0.69);
        }
      }
    }
  }
  /*--产品种类--*/
  .home-kind {
    /*box-sizing: border-box;*/
    /*background-color: #EBEEF5;*/
    width: 100%;
    height: 190px;
    background: rgba(0, 0, 0, 0.1);
    position: absolute;
    bottom: 0;
    z-index: 99;
    ul {
      display: flex;
    }
    li {
      padding: 20px 1%;
      text-align: center;
      position: relative;
      box-sizing: border-box;
      width: 20%;
      /*height: 150px;*/
      color: #BCDBF9;
      .icon {
        display: none;
        /*opacity: 0;*/
        /*transition: all 1.8s ease-in-out;*/
        animation: fadeInDown 0.15s linear;
        i {
          display: inline-block;
          width: 50px;
          height: 50px;
          margin: auto;
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100%;
        }
        .icon_1 {
          background-image: url("../assets/img/index/level_01.png");
        }
        .icon_2 {
          background-image: url("../assets/img/index/level_02.png");
        }
        .icon_3 {
          background-image: url("../assets/img/index/level_03.png");
        }
        .icon_4 {
          background-image: url("../assets/img/index/level_04.png");
        }
        .icon_5 {
          background-image: url("../assets/img/index/level_05.png");
        }
      }
      h3{
        display: inline-block;
        font-size: 22px;
        font-weight: 400;
        margin-top: 15px;
        /*margin-bottom: 10px;*/
        span {
          display: block;
          margin-top: 10px;
          height: 2px;
          width: 0;
          background-color: #0984E3;
          transition: width .5s;
        }
      }
      .number {
        display: block;
        color: #FFFFFF;
        font-size: 38px;
      }
      p {
        margin-top: 15px;
        font-size: 16px;
      }
      &:hover , &.active {
        color: #fff;
        height: 200px;
        transform: translateY(-5px);
        background: linear-gradient(63deg, #0E46E8, #3ADAFC);
        box-shadow: 5px 7px 24px 0px rgba(16, 34, 69, 0.5);
        transition: background-color .5s;
        .icon {
          display: block;
          /*opacity: 1;*/
          /*transition: all 1.8s ease-in-out;*/
          /*animation: fadeInDown 1s linear;*/
        }
        h3>span{
          width: 100%;
        }
        &:before , p{
          display: none;
        }
      }
      &:not(:first-child)::before {
        content: '';
        position: absolute;
        width: 2px;
        height: 70%;
        left: 0;
        /*background-color: #D6D6D6;*/
        background: linear-gradient(
            to bottom,
            rgba(0,0,0,0) 0%,
            rgba(0,0,0,0) 10%,
            rgba(35,198,200,0.3) 20%,
            rgba(35,198,200,0.4) 30%,
            rgba(35,198,200,0.5) 40%,
            rgba(35,198,200,0.8) 50%,
            rgba(35,198,200,0.5) 60%,
            rgba(35,198,200,0.4) 70%,
            rgba(35,198,200,0.3) 80%,
            rgba(0,0,0,0) 90%,
            rgba(0,0,0,0) 100%);
        opacity: 0.2;
      }
    }
  }

  /*--产品介绍--*/
  .product-box {
    /*display: flex;*/
    /*justify-content: space-between;*/
    /*flex-wrap:wrap;*/
    padding-bottom: 40px;
    .product-pre {
      width: 25%;
      float: left;
      /*width: 0;*/
      /*flex-grow: 1;*/
      .product-item {
        text-align: center;
        margin: 15px 20px;
        padding: 45px 10px;
        /*min-height: 200px;*/
        background: #fff;
        border-radius: 20px;
      }
      .product-img {
        width: 50%;
        max-width: 120px;
        height: auto;
        margin: 0 auto;
        position: relative;
        z-index: 1;
        img {
          width: 100%;
        }
      }
      .product-topic {
        line-height: 48px;
        font-size: 24px;
        font-weight: 400;
        color: #336FDC;
      }
      .product-info {
        margin-top: 30px;
        font-size: 20px;
        color: #8C8C8C;
        line-height: 28px;
      }

      &:hover {
        transform: translateY(-15px);
        transition: all 0.5s;
        /*box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);*/
        .product-item {
          box-shadow: 1px 11px 29px 0px rgba(42, 91, 188, 0.22);
        }
      }
    }
  }

  /*--融资流程--*/
  .process-box{
    padding: 50px 0;
    .process-pre {
      width: 16.66%;
      float: left;
      margin-bottom: 20px;
      position: relative;
      &:before {
        content: '';
        border-top: 1px dashed #DCDCDC;
        position: absolute;
        left: 60%;
        /*right: 60%;*/
        top: 37%;
        width: 100%;
        height: 1px;
        z-index: -1;
      }
      .step {
        display: block;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        color: #fff;
        width: 22px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        background: #DDDDDD;
        border-radius: 50%;
        font-family: DFPLiJinHeiW8;
        position: absolute;
        right: 0;
        top: 37%;
        margin-top: -11px;
        margin-right: -11px
      }
      &:last-child{
        &:before ,.step {
          display: none;
        }
      }

      .process-item {
        margin: 0 auto;
        width: 170px;
        height: 170px;
      }
      .process-img {
        margin: 0 auto;
        width: 130px;
        height: 130px;
        background: #fff;
        box-shadow: 1px 11px 29px 0px rgba(134, 138, 147, 0.22);
        border-radius: 50%;
        display:flex;
        align-items: center;
        justify-content: center;
        i {
          width: 70px;
          height: 70px;
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100%;
        }
        .icon-1 {
          background-image: url("../assets/img/index/step_01.png");
          /*background: url('../assets/img/index/step_01.png') no-repeat center;*/
        }
        .icon-2 {
          background-image: url("../assets/img/index/step_02.png");
        }
        .icon-3 {
          background-image: url("../assets/img/index/step_03.png");
        }
        .icon-4 {
          background-image: url("../assets/img/index/step_04.png");
        }
        .icon-5 {
          background-image: url("../assets/img/index/step_05.png");
        }
        .icon-6 {
          background-image: url("../assets/img/index/step_06.png");
        }
      }
      .process-topic {
        font-size: 22px;
        line-height: 44px;
        color: #000000;
        font-weight: bold;
        text-align: center;
      }

      &:hover {
        transition: all 2.5s;
        .process-img {
          width: 150px;
          height: 150px;
          box-shadow: 1px 11px 29px 0px rgba(42, 91, 188, 0.22);
          i {
            width: 80px;
            height: 80px;
            animation: zoomIn 0.25s linear;
          }
          .icon-1 {
            background-image: url("../assets/img/index/step_hover_01.png");
          }
          .icon-2 {
            background-image: url("../assets/img/index/step_hover_02.png");
          }
          .icon-3 {
            background-image: url("../assets/img/index/step_hover_03.png");
          }
          .icon-4 {
            background-image: url("../assets/img/index/step_hover_04.png");
          }
          .icon-5 {
            background-image: url("../assets/img/index/step_hover_05.png");
          }
          .icon-6 {
            background-image: url("../assets/img/index/step_hover_06.png");
          }
        }
        .process-topic {
          color: #336FDC;
          animation: fadeInDown 0.25s linear;
        }
      }
    }
  }

  /*--金融机构--*/
  .plugin-box {
    position: relative;
    width: 100%;
    /*min-height: 800px;*/
    background-color: #112E67;
    background-image: url("../assets/img/index/plugin-bg.png");
    background-position: center center;
    background-attachment: fixed;
    .main-title h1 {
      color: #fff;
    }

    .tool-intro {
      margin: 0 auto;
      /*width: 80%;*/
      padding: 30px 0;
      .el-carousel__item {
        .el-carousel__mask {
          display: none;
        }
        .list-item {
          opacity: .3;
          margin: 10px 22%;
          padding: 30px 20px;
          min-width: 140px;
          min-height: 200px;
          /*height: calc(100% - 50px);*/
          text-align: center;
          border-radius: 20px;
          background: #FFFFFF;
          .bank-logo {
            img {
              width: 100%;
              max-width: 316px;
            }
          }
          .bank-medium {
            margin: 10px auto;
            padding-bottom: 20px;
            font-size: 16px;
            span {
              color: #336FDC;
            }
          }
          .bank-name {
            margin: auto;
            color: #8C8C8C;
            font-size: 14px;
            width: 150px;
            text-align:center;
            position:relative;
            &:before{
              content: "";
              position: absolute;
              background: #DCDFE6;
              left: 0;
              top: 50%;
              width: 100%;
              height: 1px;
            }
            div {
              background: #fff;
              padding: 0 10px;
              position: relative;
              display: inline-block;
            }
          }
          &:hover {
            /*padding: 20px 40px;*/
            box-shadow: 0px 6px 4px 0px rgba(3, 15, 39, 0.51);
          }
        }
        /*&:nth-child(2n) {
          .list-item {
            background: #6B7EA3;
            box-shadow: 0px 6px 4px 0px rgba(3, 15, 39, 0.51);
          }
        }
        &:nth-child(2n+1) {
          .list-item {
            background: #FFFFFF;
            box-shadow: 0px 6px 4px 0px rgba(3, 15, 39, 0.51);
          }
        }*/
      }
      .is-active {
        .list-item {
          opacity: 1;
        }
      }
    }
  }

  @media screen and (min-width:1024px) and (max-width:1300px){
    .process-pre  {
      width: 33.33% !important;
      &:nth-child(3n){
        &:before ,.step {
          display: none;
        }
      }
    }
  }
  @media screen and (min-width:600px) and (max-width: 1024px){
    .product-pre  {
      width: 50% !important;
    }
    .process-pre  {
      width: 50% !important;
      &:nth-child(2n){
        &:before ,.step {
          display: none;
        }
      }
    }
    .home-kind {
      h3 {
        font-size: 20px !important;
      }
      .number {
        font-size: 34px !important;
      }
    }
  }
  @media screen and (max-width:600px){
    .product-pre {
      width: 100% !important;
    }
    .process-pre {
      width: 100% !important;
    }
  }


</style>



// WEBPACK FOOTER //
// src/views/index.vue